// import {api} from '@/util/request'

// const apiRequest = {
//     getRouters(parm){
//         return api.get('/getRouters', parm)
//     }
// }

// export default apiRequest
import jsonToFormData from "@/util/jsonToFormData";

import { api_request } from "@/util/request";

const apiRequest = {
  login(parm) {
    // 登录
    return api_request({
      url: "/login",
      method: "post",
      parm,
      isToken: false,
    });
  },
  // identificationRecognize(parm){ // ocr证件识别
  //     return api_request({
  //         url: '/baiduApi/oauth/2.0/token',
  //         urlHad: 'https://api.baidubce.com',
  //         method: 'get',
  //         parm ,
  //     })
  // },
  captchaImage(parm) {
    // 图片验证码
    return api_request({
      url: "/captchaImage",
      method: "get",
      parm,
      isToken: false,
    });
  },
  getInfo(parm) {
    // 获取用户信息
    return api_request({
      url: "/getInfo",
      method: "get",
      parm,
    });
  },
  getRoutersNew(parm) {
    //获取导航栏(新)
    return api_request({
      url: "/getRoutersNew",
      method: "get",
      parm,
    });
  },
  editUser(parm) {
    // 编辑用户信息
    return api_request({
      url: "/system/user",
      method: "put",
      parm,
    });
  },
  editAvatar(parm) {
    // 编辑用户头像
    return api_request({
      url: "/system/user/editAvatar",
      method: "put",
      parm,
    });
  },
  getCustomList(parm) {
    // 获取客户信息列表
    return api_request({
      url: "/srm/custom/list",
      method: "get",
      parm,
    });
  },
  getFactoryAreaMap(parm) {
    // 获取厂区列表
    return api_request({
      url: "/gqManage/factoryArea/getFactoryAreaMap",
      method: "get",
      parm,
    });
  },
  getFactoryAreaNoPerm(parm) {
    // 获取厂区列表（无权限限制）
    return api_request({
      url: "/gqManage/factoryArea/getAreaNoPerm",
      method: "get",
      parm,
    });
  },
  getTreelist(parm) {
    // 获取物料品类列表
    return api_request({
      url: "/gqManage/matter/treelist",
      method: "get",
      parm,
    });
  },
  getProvince(parm) {
    // 获取城市列表
    return api_request({
      url: `/system/dept/province`,
      method: "get",
      parm,
    });
  },
  addCustom(parm) {
    // 添加客户
    return api_request({
      url: `/srm/custom/addOptional`,
      method: "post",
      parm,
    });
  },
  editCustom(parm) {
    // 编辑客户
    return api_request({
      url: `/srm/custom/editOptional`,
      method: "put",
      parm,
    });
  },
  delCustom(parm) {
    // 删除客户
    return api_request({
      url: `/srm/custom/logicalDeletion/${parm.id}`,
      method: "delete",
    });
  },

  //新增企业标签
  addEnterpriseLabel(parm) {
    // 新增企业标签
    return api_request({
      url: `/srm/custom/addLabel`,
      method: "post",
      parm,
    });
  },

  //删除企业标签
  deleteEnterpriseLabel(parm) {
    // 删除企业标签
    return api_request({
      url: `/srm/custom/delLabel/${parm}`,
      method: "delete",
    });
  },

  //强制删除企业标签
  deleteForceEnterpriseLabel(parm) {
    // 强制删除企业标签
    return api_request({
      url: `/srm/custom/delMandatory/${parm}`,
      method: "delete",
    });
  },

  //获取企业标签列表
  getEnterpriseLabel(parm) {
    // 获取企业标签列表
    return api_request({
      url: `/srm/custom/getCustomLabel`,
      method: "get",
      parm,
    });
  },

  getCustom(parm) {
    // 获取客户信息
    return api_request({
      url: `/srm/custom/${parm.id}`,
      method: "get",
    });
  },
  getModifyRecord(parm) {
    // 获取跟进记录
    return api_request({
      url: `/srm/modifyRecord/list`,
      method: "get",
      parm,
    });
  },
  trackRecord(parm) {
    // 添加跟进记录
    return api_request({
      url: `/srm/trackRecord`,
      method: "post",
      parm,
    });
  },
  delTrack(parm) {
    // 删除跟进记录
    return api_request({
      url: `/srm/modifyRecord/follow/${parm.modifyRecordId}`,
      method: "delete",
    });
  },
  getUpstream(parm) {
    // 获取客户信息跟进人列表
    return api_request({
      url: `/srm/custom/getUpstream`,
      method: "get",
      parm,
    });
  },
  getChargeCustom(parm) {
    // 获取原有人员的负责的公司信息
    return api_request({
      url: `/srm/custom/getChargeCustom`,
      method: "get",
      parm,
    });
  },
  getSupplierList(parm) {
    // 获取供应商信息列表
    return api_request({
      url: `/srm/receivingCompany/list`,
      method: "get",
      parm,
    });
  },
  getSupplier(parm) {
    // 获取供应商详情
    return api_request({
      url: `/srm/receivingCompany/${parm.id}`,
      method: "get",
    });
  },
  addSupplier(parm) {
    // 新增供应商
    return api_request({
      url: `/srm/receivingCompany/addOptional`,
      method: "post",
      parm,
    });
  },
  editSupplier(parm) {
    // 编辑供应商
    return api_request({
      url: `/srm/receivingCompany/editOptional`,
      method: "put",
      parm,
    });
  },
  delSupplier(parm) {
    // 删除供应商
    return api_request({
      url: `/srm/receivingCompany/${parm.id}`,
      method: "delete",
    });
  },
  editFollower(parm) {
    // 修改跟进人或者跟进阶段 弃用
    return api_request({
      url: `/srm/receivingCompany/editFollower`,
      method: "put",
      parm,
    });
  },
  editBelong(parm) {
    // 供应商修改归属人
    return api_request({
      url: `/srm/receivingCompany/editBelong`,
      method: "put",
      parm,
    });
  },
  updateCharge(parm) {
    // 修改客户跟进人
    return api_request({
      url: `/srm/custom/updateCharge`,
      method: "put",
      parm,
    });
  },
  getFollowUpUsers(parm) {
    // 获取亘前公司市场部人员信息
    return api_request({
      url: `/system/user/followUpUsers`,
      method: "get",
      parm,
    });
  },
  exportHzDerive(parm, responseType) {
    // 合作客户导出
    return api_request({
      url: `/srm/custom/exportHz`,
      method: "post",
      parm: jsonToFormData(parm),
      responseType,
    });
  },
  exportYxDerive(parm, responseType) {
    // 潜在客户导出
    return api_request({
      url: `/srm/custom/exportYx`,
      method: "post",
      parm: jsonToFormData(parm),
      responseType,
    });
  },
  supplierDerive(parm, responseType) {
    // 供应商导出
    return api_request({
      url: `/srm/receivingCompany/export`,
      method: "post",
      parm: jsonToFormData(parm),
      responseType,
    });
  },
  supplierExportSelf(parm, responseType) {
    // 供应商自选导出
    return api_request({
      url: `/srm/receivingCompany/exportSelf`,
      method: "post",
      parm: jsonToFormData(parm),
      responseType,
    });
  },
  exportRegionStat(parm, responseType) {
    // 导出物料各省市厂家数量占比统计
    return api_request({
      url: `/srm/receivingCompany/exportRegionStat`,
      method: "post",
      parm: jsonToFormData(parm),
      responseType,
    });
  },
  recycleDerive(parm, responseType) {
    // 回收商导出
    return api_request({
      url: `/recycle/export`,
      method: "post",
      parm: jsonToFormData(parm),
      responseType,
    });
  },
  getRecycleList(parm) {
    // 获取回收站列表
    return api_request({
      url: `/recycle/list`,
      method: "get",
      parm,
    });
  },
  addRecycle(parm) {
    // 新增回收商
    return api_request({
      url: `/recycle/addOptional`,
      method: "post",
      parm,
    });
  },
  editRecycle(parm) {
    // 编辑回收商
    return api_request({
      url: `/recycle/editOptional`,
      method: "put",
      parm,
    });
  },
  delRecycle(parm) {
    // 删除回收商
    return api_request({
      url: `/recycle/matter/${parm.id}`,
      method: "delete",
    });
  },
  getRecycle(parm) {
    // 获取回收商详情
    return api_request({
      url: `/recycle/${parm.id}`,
      method: "get",
    });
  },
  getMaterials(parm) {
    // 获取物料品类
    return api_request({
      url: `/srm/materials/dept`,
      method: "get",
      parm,
    });
  },
  getMaterialsCoding(parm) {
    // 获取物料编码列表
    return api_request({
      url: `/srm/materialsPrice/list`,
      method: "get",
      parm,
    });
  },
  addMaterials(parm) {
    // 添加物料
    return api_request({
      url: `/srm/materialsPrice`,
      method: "post",
      parm,
    });
  },
  editMaterials(parm) {
    // 编辑物料
    return api_request({
      url: `/srm/materialsPrice`,
      method: "put",
      parm,
    });
  },
  delMaterials(parm) {
    // 删除物料
    return api_request({
      url: `/srm/materials/${parm.id}`,
      method: "delete",
      parm,
    });
  },
  changeLoc(parm) {
    // 拖拽物料
    return api_request({
      url: `/srm/materials/changeLoc`,
      method: "put",
      parm,
    });
  },
  upMaterialsPrice(parm) {
    // 导入物料
    return api_request({
      url: `/srm/materialsPrice/importData`,
      method: "post",
      parm: jsonToFormData(parm),
      contentType: "multipart/form-dat",
    });
  },
  getCustomSource(parm) {
    // 获取客户来源
    return api_request({
      url: `/srm/custom/getCustomSource`,
      method: "get",
      parm,
    });
  },
  getLatestInfo(parm) {
    // 获取客户历史记录
    return api_request({
      url: `/srm/customHis/latestInfo`,
      method: "get",
      parm,
      // toast: false,
    });
  },
  importHzTemplate(parm, responseType) {
    // 下载合作客户模版
    return api_request({
      url: `/srm/custom/importHzTemplate`,
      method: "post",
      // parm: jsonToFormData(parm),
      responseType,
    });
  },
  importErrorLog(parm, responseType) {
    // 导出错误日志
    return api_request({
      url: `/importErrorLog/export`,
      method: "post",
      parm: parm,
      toast: false,
      responseType,
    });
  },
  importDataHz(parm) {
    // 导入合作客户列表
    return api_request({
      url: `/srm/custom/importDataHz`,
      method: "post",
      parm: jsonToFormData(parm),
      contentType: "multipart/form-dat",
    });
  },
  importYxTemplate(parm, responseType) {
    // 下载潜在客户模版
    return api_request({
      url: `/srm/custom/importYxTemplate`,
      method: "post",
      // parm: jsonToFormData(parm),
      responseType,
    });
  },
  importDataYx(parm) {
    // 导入潜在客户列表
    return api_request({
      url: `/srm/custom/importDataYx`,
      method: "post",
      parm: jsonToFormData(parm),
      contentType: "multipart/form-dat",
    });
  },
  supplierTemplate(parm, responseType) {
    // 下载供应商模版
    return api_request({
      url: `/srm/receivingCompany/importTemplate`,
      method: "post",
      // parm: jsonToFormData(parm),
      responseType,
    });
  },
  importSupplier(parm) {
    // 导入供应商列表
    return api_request({
      url: `/srm/receivingCompany/importData`,
      method: "post",
      parm: jsonToFormData(parm),
      contentType: "multipart/form-dat",
    });
  },
  recycleTemplate(parm, responseType) {
    // 下载回收商模版
    return api_request({
      url: `/recycle/importTemplate`,
      method: "post",
      // parm: jsonToFormData(parm),
      responseType,
    });
  },
  importRecycle(parm) {
    // 导入回收商列表
    return api_request({
      url: `/recycle/importData`,
      method: "post",
      parm: jsonToFormData(parm),
      contentType: "multipart/form-dat",
    });
  },
  upRecyclePrice(parm) {
    // 导入回收价格表
    return api_request({
      url: `/srm/materialsReference/importData`,
      method: "post",
      parm: jsonToFormData(parm),
      contentType: "multipart/form-dat",
    });
  },
  getRawMaterial(parm) {
    // 获取原材料列表
    return api_request({
      url: `/srm/receivingCompany/getRawMaterial`,
      method: "get",
      parm,
    });
  },
  getExportConfig(parm) {
    // 获取当前模块的导出配置信息
    return api_request({
      url: `/srm/exportConfig/getExportConfig`,
      method: "get",
      parm,
    });
  },

  getCustomSiftList(parm) {
    // 自定义筛选列表
    return api_request({
      url: `/inquiry/inquiryConfig/list`,
      method: "get",
      parm,
    });
  },
  getFieldList(parm) {
    // 已选筛选列表
    return api_request({
      url: `/inquiry/inquiryConfig/fieldList`,
      method: "get",
      parm,
    });
  },
  submitCustomSift(parm) {
    // 修改已选字段
    return api_request({
      url: `/inquiry/inquiryConfig/userBindField`,
      method: "post",
      parm,
    });
  },
  getOCRUrl(parm) {
    // 图片识别
    return api_request({
      url: `/orc/getOCRUrl`,
      method: "get",
      parm,
      toast: false,
    });
  },
  getServiceList(parm) {
    // 获取服务商列表
    return api_request({
      url: `/srm/provider/list`,
      method: "get",
      parm,
    });
  },
  getService(parm) {
    // 获取服务商详情
    return api_request({
      url: `/srm/provider/${parm.id}`,
      method: "get",
      parm,
    });
  },
  addService(parm) {
    // 添加服务商
    return api_request({
      url: `/srm/provider`,
      method: "post",
      parm,
    });
  },
  editService(parm) {
    // 编辑服务商
    return api_request({
      url: `/srm/provider`,
      method: "put",
      parm,
    });
  },
  serviceTemplate(parm, responseType) {
    // 下载服务商商模版
    return api_request({
      url: `/srm/provider/importTemplate`,
      method: "post",
      // parm: jsonToFormData(parm),
      responseType,
    });
  },
  importService(parm, responseType) {
    // 导入服务商模版
    return api_request({
      url: `/srm/provider/importData`,
      method: "post",
      parm: jsonToFormData(parm),
      contentType: "multipart/form-dat",
    });
  },
  serviceDerive(parm, responseType) {
    // 服务商导出
    return api_request({
      url: `/srm/provider/export`,
      method: "post",
      parm: jsonToFormData(parm),
      responseType,
    });
  },
  serviceBelong(parm) {
    // 修改服务商归属人
    return api_request({
      url: `/srm/provider/editBelong/${parm.providerId}/${parm.belongId}`,
      method: "put",
    });
  },
  delService(parm) {
    // 删除服务商
    return api_request({
      url: `/srm/provider/${parm.id}`,
      method: "delete",
    });
  },
  recycleBelong(parm) {
    // 修改回收商归属人
    return api_request({
      url: `/recycle/editBelong`,
      method: "put",
      parm,
    });
  },

  getCooperationList(parm) {
    // 获取合作意向列表
    return api_request({
      url: `/intention/cooperationIntention/list`,
      method: "get",
      parm,
    });
  },
  editCooperationStatus(parm) {
    // 修改合作意向
    return api_request({
      url: `/intention/cooperationIntention`,
      method: "put",
      parm,
    });
  },
  cooperationDerive(parm, responseType) {
    // 合作意向导出
    return api_request({
      url: `/intention/cooperationIntention/export`,
      method: "post",
      parm: jsonToFormData(parm),
      responseType,
    });
  },
  //-----------------------------物料知识---------------------------
  changeMatterKonwledgeLoc(parm) {
    // 拖拽物料
    return api_request({
      url: `/knowledge/materialKnowledge/changeLoc`,
      method: "put",
      parm,
    });
  },
  getMatterTree(parm) {
    // 获取物料知识信息树
    return api_request({
      url: `/knowledge/materialKnowledge/listTree`,
      method: "get",
      parm,
    });
  },
  getMatterDetail(parm) {
    // 获取当前物料详情
    return api_request({
      url: `/knowledge/materialKnowledge/${parm}`,
      method: "get",
    });
  },
  addMatter(parm) {
    // 新增物料知识
    return api_request({
      url: `/knowledge/materialKnowledge`,
      method: "post",
      parm,
    });
  },
  editMatter(parm) {
    // 编辑物料知识
    return api_request({
      url: `/knowledge/materialKnowledge`,
      method: "put",
      parm,
    });
  },

  deleteMatter(parm) {
    // 删除物料知识
    return api_request({
      url: `/knowledge/materialKnowledge/${parm}`,
      method: "delete",
    });
  },

  downloadFile(fileId, fileName, responseType) {
    // 下载文件
    return api_request({
      url: `/gqManage/download-file/${fileId}`,
      method: "get",
      responseType,
      parm: { fileName }, // 将文件名作为请求参数传递
    });
  },

  //----------------------物料云库相关接口-----------------------------
  //获取客户信息、处理方列表统计数据
  getMatterLibraryStatistics() {
    // 获取客户信息、处理方列表统计数据
    return api_request({
      url: `/srm/collaborator/cloudCount`,
      method: "get",
    });
  },
  getMatterLibraryCustomList(parm) {
    // 查询客户信息列表
    return api_request({
      url: `/srm/custom/cloudCustomList`,
      method: "get",
      parm,
    });
  },

  getMatterLibraryProcessList(parm) {
    // 查询处理方列表
    return api_request({
      url: `/srm/collaborator/list`,
      method: "get",
      parm,
    });
  },

  getAllMatterTag(parm) {
    // 获取当前用户所有物料标签
    return api_request({
      url: `/srm/materials/getMaterialLabel`,
      method: "get",
      parm,
    });
  },

  getSelectMatterTag(parm) {
    // 获取已选物料标签
    return api_request({
      url: `/srm/materials/getMaterialLabelCount`,
      method: "post",
      parm,
    });
  },

  addMatterTag(parm) {
    // 新增物料标签
    return api_request({
      url: `/srm/materials/addLabel`,
      method: "post",
      parm,
    });
  },

  deleteMatterTag(parm) {
    // 删除物料标签
    return api_request({
      url: `/srm/materials/delLabel/${parm}`,
      method: "delete",
    });
  },
};

export default apiRequest;
